import React, { useEffect, useState } from 'react';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import { useStaff } from '../../../DataStore/StaffContext';
import ajaxReport from '../../../util/remote/ajaxReport';


const SetMarksInitials = ({reportId, paperId}) => {

    const [currentNotify, setNotify] = useState(null);
    const {listing, getStaffMembers} = useStaff();
    const [teacherId, setTeacherId] = useState("");
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        getStaffMembers();
    }, []);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
         if(teacherId>0){   
            setNotify(<ActivityLoader/>)
              setLoading(true);
           const server_response = await ajaxReport.addReportInitials(reportId, teacherId, paperId);
              setLoading(false);
           if(server_response.status==="OK")
           {
            setNotify(<Notification type='success' message={server_response.message}/>);
           }else{
             setNotify(<Notification type='danger' message={server_response.message}/>);

           }

        }else{
            setNotify(<Notification type='danger' message="Select staff and try again"/>);
        }



    }


    const onChangeTeacher=(option)=>setTeacherId(option.value)


     const RenderTeacher=()=>{

        const optionsListing=[];

        if(Array.isArray(listing))
        {
            listing.map((item, key)=>
            optionsListing.push({label:item.last_name + " " + item.first_name, value:item.staff_id})
            )
            }

            return(
                <TextInput
                    label="Subject Initials"
                    leftIcon="fa fa-user"
                    type="select" 
                    placeholder="Select staff...." 
                    options={optionsListing}
                    onChange={onChangeTeacher}
                    leftComponent={<i className="fa fa-user txt-primary"/>}
                    wrap
            />
                
            )
            
     }
     
  

    return (
        <div className="card-body">

            <CallOut 
                title="Marks Initials"
                description="Set teacher initials responsible for this subject mark. This will affect all students for this subject specifically for this reports batch. Make sure you reload the reports to view changes."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

               {RenderTeacher()}

                

                <div className="text-right">
                    {!loading && <button type="submit" className="btn btn-lg btn-primary">Set Initials</button>}
                </div>

            </form> 


        </div>
    );
};

export default SetMarksInitials;